import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'linkify', standalone: true, pure: true })
export class LinkifyPipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);

  transform(value: string | null | undefined): SafeHtml | null {
    if (value) {
      const linkRegex = /https?:\/\/[^\\"<]*?(?=\s|$|<\/[^a]+>)/g;
      const html = value.replace(linkRegex, (match) => `<a href="${match}" target="_blank" rel="noopener noreferrer">${match}</a>`);
      return this.sanitizer.bypassSecurityTrustHtml(html);
    } else return null;
  }
}
